// AdminWidgetsSpec.system.js — 시스템 그룹 위젯 — 사용자 결정에 따라 전부 제거 (2026-06-06)

export const SYSTEM_SPECS = {};
